/**
 * GraphQL Operation — Card Mollie KPI Widget (Phase 16 Plan 16-07, REPORT-03)
 *
 * Liefert die 4 aggregierten Dashboard-Kennzahlen (Redis-cached 60s pro Tenant).
 */
import {gql} from "@apollo/client";

export const GET_MOLLIE_KPIS = gql`
    query getMollieKpis {
        getMollieKpis {
            openLinksCount
            openLinksSum
            chargebacks30dCount
            chargebacks30dFee
            successRate30d
            avgCheckoutToPaidHours
        }
    }
`;
